export default "__VITE_ASSET__250ce41d__"